import React from 'react';
import './MissionVisionSection.css';
import robotArmImage from '../assets/robot-arm.png'; 
const MissionVisionSection = () => {
  return (
    <section className="mission-vision-section">
      <div className="container mission-vision-grid">
        <div className="mission-vision-text">
          <h2 className="section-subtitle">Nuestra misión</h2>
          <h2>Nuestra visión</h2>
          <p>
            Cada idea nace con el potencial de convertirse en algo grande. En ForTe<span>{'{'}</span>{' '}creemos que los
            emprendedores necesitan un aliado que los acompañe a transformar su visión en una marca
            sólida, con presencia digital y física. Somos ese
            puente entre la idea y la realidad.
          </p>
        </div>
        <div className="robot-arm-image-container">
          <img src={robotArmImage} alt="Mano robótica tecnológica" className="robot-arm-img" />
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;